<template>
    <div>Pivot</div>
</template>

<script>
/* eslint-disable */
import store from "../../store/index";
import axios from 'axios';
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.toolbar.min.js";
import "webdatarocks/webdatarocks.js";
export default {
  name: "querystatusPivot",
  props: {
    afterchartdraw: Function,
    aftergriddraw: Function,
    beforegriddraw: Function,
    beforetoolbarcreated: Function,
    cellclick: Function,
    celldoubleclick: Function,
    componentFolder: String,
    customizeCell: Function,
    customizeContextMenu: Function,
    datachanged: Function,
    dataerror: Function,
    datafilecancelled: Function,
    dataloaded: Function,
    fieldslistclose: Function,
    fieldslistopen: Function,
    filterclose: Function,
    filteropen: Function,
    fullscreen: Function,
    global: Object,
    height: [String, Number],
    loadingdata: Function,
    loadinglocalization: Function,
    loadingolapstructure: Function,
    loadingreportfile: Function,
    localizationerror: Function,
    localizationloaded: Function,
    olapstructureerror: Function,
    olapstructureloaded: Function,
    openingreportfile: Function,
    querycomplete: Function,
    queryerror: Function,
    ready: Function,
    report: [String, Object],
    reportchange: Function,
    reportcomplete: Function,
    reportfilecancelled: Function,
    reportfileerror: Function,
    reportfileloaded: Function,
    runningquery: Function,
    toolbar: Boolean,
    update: Function,
    width: [Number, String]
  },
      data() {
    return {
      baseapi: process.env.VUE_APP_Service_URL,
      reportdata: []
    }
      },
  mounted: function() {
    window.addEventListener("studyIdChanged", (event) => {
      this.reportfun();
    });
    this.reportfun();
    this.webdatarocks = new WebDataRocks({
      ...this.$props,
      container: this.$el,
      beforetoolbarcreated: this.customizeToolbar,
      report: {}
    });
  },
  beforeUpdate() {
    return false;
  },
  methods: {
    async reportfun(){
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      console.log("[QueryStatusReport] Fetching data for StudyId:", currentstudy);
      await axios
          .get(`${this.baseapi}/report/query/getqueryreport?StudyId=${currentstudy}`,
              {
                  headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",

                  },
              }
          )
          .then((res) => {
   console.log("[QueryStatusReport] API response:", res.data);
    const flattenedData = res.data.map(item => ({
      ...item,
      assignedTo: Array.isArray(item.assignedTo) ? item.assignedTo[0] : item.assignedTo,
      closedDate: item.closedDate ? item.closedDate : "",
      openDate: item.openDate ? item.openDate : ""
    }));
     const dataWithMetadata = [
      {
        "queryId": {},
        "subjectId": {},
        "visit": {},
        "formField": {},
        "queryText": {},
        "queryType": {},
        "priority": {},
        "status": {},
        "daysOpen": {},
        "openedBy": {},
        "openDate": { "type": "string" },
        "closedDate": { "type": "string" },
        "assignedTo": {}
      },
      ...flattenedData
    ];
    this.reportdata = flattenedData;
    
    let setrept = {
      dataSource: {
        data: dataWithMetadata,
      },
      "options": {
        "grid": {
            "type": "flat",
            "showGrandTotals": "off"
        }
    },
        "slice": {
                    "rows": [
      { "uniqueName": "queryId"},
      { "uniqueName": "subjectId" },
      { "uniqueName": "visit" },
      { "uniqueName": "formField" },
      { "uniqueName": "queryText" },
      { "uniqueName": "queryType" },
      { "uniqueName": "priority" },
      { "uniqueName": "status" },
      { "uniqueName": "daysOpen" },
      { "uniqueName": "openedBy" },
      { "uniqueName": "openDate" },
      { "uniqueName": "closedDate" },
      { "uniqueName": "assignedTo" }
        ],
        "columns": [
      {"uniqueName": "queryId" },
      {"uniqueName": "subjectId" },
      {"uniqueName": "visit" },
      {"uniqueName": "formField" },
      {"uniqueName": "queryText" },
      {"uniqueName": "queryType" },
      {"uniqueName": "priority" },
      {"uniqueName": "status" },
      { "uniqueName": "daysOpen" },
      {"uniqueName": "openedBy" },
      {"uniqueName": "openDate" },
      {"uniqueName": "closedDate" },
      {"uniqueName": "assignedTo" }

    ],
        "measures": [
      {"uniqueName": "queryId" },
      {"uniqueName": "subjectId" },
      {"uniqueName": "visit" },
      {"uniqueName": "formField" },
      {"uniqueName": "queryText" },
      {"uniqueName": "queryType" },
      {"uniqueName": "priority" },
      {"uniqueName": "status" },
      { "uniqueName": "daysOpen" },
      {"uniqueName": "openedBy" },
      {"uniqueName": "openDate" },
      {"uniqueName": "closedDate" },
      {"uniqueName": "assignedTo" }
        ]


    },
      }
      this.webdatarocks.setReport(setrept);
          })
          .catch((err) => {
              console.error("[QueryStatusReport] API error:", err);
          });
    },
    customizeToolbar(toolbar) {
        var tabs = toolbar.getTabs(); // get all tabs from the toolbar
        toolbar.getTabs = function () {
            delete tabs[0];
            delete tabs[1]; // delete the second tab
            return tabs;
        }

    }
  }
};
</script>
<style scoped>
@import '~webdatarocks/webdatarocks.min.css';
</style>